import MobileDetect from 'mobile-detect';

export default {

    MobileDetect,

    // eslint-disable-next-line
    install(Vue, opts) {
        Vue.prototype.$md = new MobileDetect(window.navigator.userAgent);
    }

}
